/**
 * @param {string} url
 * @param {[string, string][]} params
 */
export const joinUrl = (url, params) => {
	const u = new URL(url, window.location.origin);

	// eslint-disable-next-line array-element-newline
	for (let [key, value] of params) {
		if (key === 'page') {
			u.searchParams.set(key, decodeURIComponent(value));
		} else {
			u.searchParams.append(key, decodeURIComponent(value));
		}
	}

	return u.toString();
};

export const joinUrlHash = (url, params) => {
	const u = new URL(url, window.location.origin);
	const searchParams = new URLSearchParams(u.hash.slice(1));

	// eslint-disable-next-line array-element-newline
	for (let [key, value] of params) {
		searchParams.append(key, decodeURIComponent(value));
	}

	u.hash = searchParams.toString();

	return u.toString();
};

export const getUrlPathNameAndSearch = url => {
	const u = new URL(url, window.location.origin);

	return u.pathname + u.search;
};

export const replaceUrlOrigin = url => {
	const pathname = getUrlPathNameAndSearch(url ?? '');

	return new URL(pathname, window.location.origin).toString();
};
